import LegalPage from "@/components/LegalPage";
export default function Cookies() {
  return <LegalPage contentKey="cookiePolicyPage" />;
}
